import { render, staticRenderFns } from "./CruiseDetailFeatures.vue?vue&type=template&id=4b2d8f9a&scoped=true"
import script from "./CruiseDetailFeatures.vue?vue&type=script&lang=js"
export * from "./CruiseDetailFeatures.vue?vue&type=script&lang=js"
import style0 from "./CruiseDetailFeatures.vue?vue&type=style&index=0&id=4b2d8f9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2d8f9a",
  null
  
)

export default component.exports